<template>
  <input-widget
      type="select2"
      :attribute="attribute"
      :items="availableBranches"
      :options="options"
      :label="label"
      display-field="${item.name}"
      :model="model"/>
</template>


<script>
  import InputWidget from "../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  const {mapState: mapStateBranch} = createNamespacedHelpers('setup/branch');

  export default {
    name: "BranchSearchSelectInputWidget",
    components: {InputWidget},
    data() {
      return {
        selectedBranches: []
      }
    },
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      label: {
        type: [String, Boolean],
        default: null
      }
    },
    methods: {},
    mounted() {
    },
    computed: {
      ...mapStateBranch(['branches']),
      availableBranches() {
        return this.branches.rows.filter(opt => this.selectedBranches.map(b => b.uuid).indexOf(opt.uuid) === -1)
      }
    }
  }
</script>

<style scoped>

</style>
